exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".overlay{display:-ms-flexbox;display:flex;position:fixed;width:100%;height:100%;min-height:100vh;left:0;top:0;z-index:1000;background:rgba(0,0,0,.7)}.overlay__img{margin:auto;width:400px;height:auto;transform:scale(1.5)}.overlay__close{display:block;position:absolute;width:50px;height:50px;top:30px;right:30px;background:url(" + require("../assets/share/cancel.svg") + ");background-size:cover;opacity:.3}.overlay__close:hover{opacity:.5}@media only screen and (max-width:935px){.overlay__img{width:400px;transform:scale(1.3)}.overlay__close{width:30px;height:30px;top:30px;right:30px}}@media only screen and (max-width:730px){.overlay__img{width:400px;transform:scale(1.1)}.overlay__close{width:20px;height:20px;top:30px;right:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0066c5fd","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overlay.vue
// module id = 21
// module chunks = 0